// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-request__col--text-align-center{text-align:center}@media (min-width:0px) and (max-width:575px){.booking-request__col--text-align-left-xs-max{text-align:left}}.booking-request__alert{width:100%}.booking-request__disclaimer{margin:0 auto;max-width:575px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
